import { Component, Inject, OnInit, Renderer2, ViewChild, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MasterdataService } from 'src/app/home/services/masterdata.service';

@Component({
  selector: 'app-add-master-product',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-master-product.component.html',
  styleUrls: ['./add-master-product.component.scss', '../../../../app.component.scss', '../../../../shared/base-modal.style.scss']
})
export class AddMasterProductComponent implements OnInit {
  public propData: any;
  public regions: any;
  public country: any;
  public selectedRegion: any = { id: "", value: "" };
  public selectedCountry: any = { id: "", value: "" };
  public isEdited: boolean = false;
  public nameTxt: string;
  public search: any;

  isRegionDropDown = signal(false);
  isCountryDropDown = signal(false);

  constructor(
    public dialogRef: MatDialogRef<AddMasterProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private masterdataService: MasterdataService,
    private renderer: Renderer2
  ) {
    if (data) {
      this.propData = data;
      this.regions = this.propData.regions;
      this.country = this.propData.country;
    }
  }

  ngOnInit(): void {
    if (this.propData && this.propData.type === "edit") {
      let regions = this.propData.regions || [];
      let country = this.propData.country || [];

      let regionIdToFind = this.propData.item.region_id;
      this.selectedRegion = regions.find((r: any) => r.id === regionIdToFind) || this.selectedRegion;

      let countryIdToFind = this.propData.item.country_id;
      this.selectedCountry = country.find((c: any) => c.id === countryIdToFind) || this.selectedCountry;

      this.nameTxt = this.propData.item.name;
      this.isEdited = true;
    }

    this.renderer.listen('window', 'click', (e: Event) => {
      if (!document.querySelector('.cabinet-dropdown.stores')?.contains(e.target as Node)) {
        this.isRegionDropDown.set(false);
        // this.isCountryDropDown.set(false);
      }
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onRegionTypeChange(value: any) {
    this.selectedRegion = value;
    this.isRegionDropDown.set(false);
  }

  onCountryTypeChange(value: any) {
    this.selectedCountry = value;
    this.isCountryDropDown.set(false);
  }

  onAdd() {
    let data = {
      region_id: this.selectedRegion.id,
      country_id: this.selectedCountry.id,
      name: this.nameTxt
    };
    if (this.isEdited) {
      this.masterdataService.masterEditBody('locations', this.propData.item.id, data).subscribe((res: any) => {
        this.onClose();
      });
    } else {
      this.masterdataService.masterAddItem('locations', data).subscribe((res: any) => {
        this.onClose();
      });
    }
  }
}
